/**
 * @(#)2019/9/17.
 * String，接管表单变化
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxString, { defaultProps } from "./YxString";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import PropTypes from "prop-types";
YxString.propTypes = {
  ...IYxInputPropTypes,
  valueSplit: PropTypes.string,
};

YxString.defaultProps = defaultProps();

export default YxString;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/String/index.js